export default __webpack_public_path__ + "static/media/KC.Chandler.resume.f6597e55.pdf";